import { getStoredAdmin } from '@/services/api'

export function sidebarStateKey() {
  const id = getStoredAdmin()?.id
  return id == null ? null : `moroorato.sidebar.v1.${id}`
}
export function readSidebarState(key) {
  if (!key) return null
  try {
    const value = JSON.parse(localStorage.getItem(key))
    return value && value.version === 1 ? value : null
  } catch { return null }
}
export function writeSidebarState(key, state) {
  if (!key) return
  try { localStorage.setItem(key, JSON.stringify({ ...state, version: 1 })) } catch { /* Storage may be disabled; navigation still works. */ }
}
